<mat-card class="form-ui">
  <mat-card-title>New batch</mat-card-title>
  <form class="mt-3">
    <div [formGroup]="batchDetailsForm">
      <div class="row">
        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Batch number</mat-label>
              <input
                required
                type="text"
                formControlName="batchNumber"
                matInput
                placeholder="Batch number"
              />
              <mat-error *ngIf="batchDetailsForm.get('batchNumber')?.invalid">
                Batch number is invalid
              </mat-error>
              <mat-hint>Examples AMI001, BOLT025, ABC2345</mat-hint>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline">
              <mat-label>Quantity</mat-label>
              <input
                required
                type="number"
                min="1"
                max="1000"
                formControlName="quantity"
                matInput
                placeholder="Quantity"
              />
              <mat-error *ngIf="batchDetailsForm.get('quantity')?.invalid">
                Batch quantity is invalid
              </mat-error>
              <mat-hint> A minimum of 1 and a maximum of 1000 </mat-hint>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline">
              <mat-label>Select package type</mat-label>
              <mat-select
                required
                [disabled]="
                  isLoading || medicineDosageTypePackageTypes.length === 0
                "
                formControlName="packageTypeId"
              >
                <mat-option
                  *ngFor="let type of medicineDosageTypePackageTypes"
                  value="{{ type.id }}"
                >
                  {{ type.package_type.type }} ({{ type.contained_quantity }})
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline">
              <mat-label>Expiry date</mat-label>
              <input
                required
                data-testid="expiry-date"
                formControlName="expiryDate"
                matInput
                [matDatepicker]="picker1"
                [min]="minDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-error *ngIf="batchDetailsForm.get('expiryDate')?.invalid">
                Expiry date is invalid
              </mat-error>
            </mat-form-field>
          </p>
        </div>

        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Search for medicine</mat-label>
              <input
                required
                [disabled]="isLoading"
                type="text"
                placeholder="Search for medicine"
                aria-label="Search for medicine"
                matInput
                formControlName="medicine"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                (optionSelected)="medicineSelected($event)"
                autoActiveFirstOption
                #auto="matAutocomplete"
              >
                <mat-option *ngFor="let med of medicine" [value]="med">
                  {{ med.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline">
              <mat-label>Dosage type</mat-label>
              <mat-select
                required
                [disabled]="isLoading || !selectedMedicine"
                formControlName="dosageTypeId"
                (selectionChange)="getMedicineDosagePackageTypes($event)"
              >
                <mat-option
                  [disabled]="type.is_active === 0"
                  *ngFor="let type of dosageTypes"
                  [value]="type.id"
                >
                  {{ type.additional_information }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="batchDetailsForm.get('dosageTypeId')?.invalid">
                Batch dosage type is invalid
              </mat-error>
            </mat-form-field>
          </p>

          <p>
            <mat-form-field appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select
                required
                [disabled]="isLoading"
                formControlName="statusId"
              >
                <mat-option
                  *ngFor="let status of batchStatuses"
                  [value]="status.id"
                  >{{ status.status }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="batchDetailsForm.get('statusId')?.invalid">
                Status is invalid
              </mat-error>
            </mat-form-field>
          </p>
        </div>
      </div>
      <div>
        <h4>Additional information</h4>
        <quill-editor
          formControlName="additional_information"
          format="html"
          [styles]="{ minHeight: '100px' }"
        >
        </quill-editor>
      </div>
    </div>
  </form>
  <mat-card-actions align="end">
    <button
      [disabled]="!batchDetailsForm.valid"
      color="primary"
      mat-raised-button
      (click)="submitData()"
    >
      <mat-icon>save</mat-icon> Save
    </button>
  </mat-card-actions>
</mat-card>
